// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"500":"e83d68a4","592":"3f39a4c1","912":"75d82c41","952":"6702b354"}[chunkId] + ".chunk.js";
};